const propertiesReg = /([^\s=]+)=(['"\s]?)([^'"]+)\2(?=\s|$|>)/g
const mediaSeed = /(<my-audio.*?<\/my-audio>)|(<my-video).*?<\/my-video>/g

export default html => {
  const audiosElements = getProperties(html.match(mediaSeed))
  const chunks = html.replace(mediaSeed, '==SPLITFLAG==').split('==SPLITFLAG==')

  let res = []
  audiosElements.forEach(item => {
    res.push(chunks.shift())
    res.push(item)
  })

  res = res.concat(chunks)

  return res
}

function getProperties (els, type) {
  if (!els || !els.length) return []
  const res = []
  for (let i = 0; i < els.length; i++) {
    const el = {}
    const items = els[i].match(propertiesReg)
    for (let j = 0; j < items.length; j++) {
      const kv = items[j].split('=')
      kv[1] && (el[kv[0]] = kv[1].replace(/(^")|("$)/g, ''))
    }

    res.push(el)
  }

  return res
}
